export class Controller {
	/** @ngInject */
	constructor(
		$http,
		$window
	) {
		this.$http = $http;
		this.$window = $window;
	}
	exportAs(format) {
		//const form = document.forms.ff2;
		//console.log(form);
		//form.submit();
		const exportList = this.items().map((item) => select(item, this.fields));

		// FIXME: Workaround. Remove when back-end is fixed.
		if (this.template === 'applications') {
			exportList.unshift({});
		}



		var req = {
			method: 'POST',
			url: `app/rest/reports/${format}/${this.template}`,
			headers: {
				'Content-Type': 'application/json',
				'timeZone': new Date().getTimezoneOffset(),
				'exportName': this.name
			},
			data: exportList,
			responseType: 'blob'
		}
		console.log(req);
		var a = document.createElement("a");
		document.body.appendChild(a);
		this.$http(req).then((response) => {
			console.log(response);
			//var disposition = headers('Content-Disposition');

			var filename = getFileNameFromHttpResponse(response);
			console.log(filename);
			//this.$window.navigator.msSaveOrOpenBlob(response.data, filename);
			var fileURL = this.$window.URL.createObjectURL(response.data);
			a.href = fileURL;
			a.download = filename;
			a.click();
			setTimeout(function() { this.$window.URL.revokeObjectURL(fileURL); }, 100);
		});

	}

	items() {
		return this.stTable.getFilteredCollection();
	}

	onSubmitted() {
		console.log("F@@@@@2222222");

	}
}

function select(obj, props) {
	return props.reduce((acc, path) => {
		const parts = path.split('.');
		const prop = parts.slice(-1)[0];
		return { ...acc, [prop]: parts.reduce((o, p) => o[p], obj) };
	}, {});
}

function submit(target, data, exportList) {

	const form = document.forms.exportForm;
	Object.keys(data)
		.forEach((key) => form.elements[key].value = data[key]);
	form.data = exportList
	form.action = target;
	//form.$http(req).
	console.log(form);
	form.submit();
}

function getFileNameFromHttpResponse(httpResponse) {
	var contentDispositionHeader = httpResponse.headers('Content-Disposition');
	var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
	return result.replace(/"/g, '');
}




// WEBPACK FOOTER //
// ./src/portal/components/smart-table/export/st-export.controller.js